/* Minimum de commande (Claude, oct. 2026, demande d'Ed) : une quantite tapee au clavier (ou la marge de pose
   decochee) ne peut pas passer sous le minimum (champ data-mpn-moq) ; le m² du calculateur suit. */
(function () {
  if (window.__mpnMoqPdp) return; window.__mpnMoqPdp = true;
  function fix(e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('input.quantity__input[data-mpn-moq]')) return;
    setTimeout(function () { clamp(t); }, 0);
  }
  function clamp(t) {
    if (!t || !t.matches || !t.matches('input.quantity__input[data-mpn-moq]')) return;
    var min = parseInt(t.getAttribute('min'), 10) || 1;
    var v = parseInt(t.value, 10);
    if (!isNaN(v) && v >= min) return;
    t.value = min;
    var calc = t.closest('quantity-calculator');
    if (calc && typeof calc.updateVolume === 'function' && calc.volumeInput) { try { calc.updateVolume(); } catch (err) {} }
    else if (calc && typeof calc.updatePrice === 'function') { try { calc.updatePrice(min); } catch (err) {} }
  }
  ['change', 'blur', 'quantity:sync'].forEach(function (type) { document.addEventListener(type, fix, true); });
})();
